<!-- src/components/Shared/IndexView.vue -->
<template>
    <section class="loading-overlay">
		<div class="lds-ring">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
    </section>
</template>

<script>

export default {
    mounted () {
		this.checkRedirect();
    },
	methods: {
		checkRedirect() {
			let self = this;
			const checkAuth = setInterval(function () {
				if (self.checkIfUserIsLoggedIn()) {
          clearInterval(checkAuth);
					self.redirectUser();
				}
			}, 100);
		},
		checkIfUserIsLoggedIn() {
			return this.$root.$data.auth.user.id > 0;
		},
		redirectUser() {
      let auth = this.$root.$data.auth;
			let roles = auth.user.roles;
			
			if (!roles) {
				this.$router.push("Projects");
				return;
			}
			if (roles.indexOf("sales") > -1) {
				this.$router.push("Subscribers");
				return;
			}
			this.$router.push("Projects");
		},
	}
}
</script>

<style>
.loading-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  cursor: pointer;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  margin-left: 50%;
  margin-top: 30%;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #81b920;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #81b920 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

